/* Purpose: All Loans from all clients mapped out into cards with LoanID, type, and client name, notes and view client's data button
 * Props: allClients(map)
 *          setAllClients (setState)
 *          allLoans (map)
 *          setAllLoans (setState)
 *          handleViewData (func)
 *          credentials (map)
 *          username
 * Author: R. Markowitz (May 2025)
 * Dev Notes: 
*/

import React from "react";
import { useState, useEffect } from "react";
import SubmitButton from './Button';
import { Row, Card, Col, Badge, Stack } from 'react-bootstrap';
import NoteModal from "./NoteModal";

const AdminLoans = ({allClients, setAllClients, allLoans, setAllLoans, handleViewData, credentials, username}) => {

    const [showNoteModal, setShowNoteModal] = useState(false)
    const [chosenLoan, setChosenLoan] = useState({});

    const handleViewNotes = (loan) => {
        setChosenLoan(loan);
        setShowNoteModal(true);
    }

    return (
        <Row xs={1} md={3} className="g-4 m-5"> 
            {allLoans && allLoans.map((loan, index) => (
                <Col key = {index} className="d-flex col-sm ">
                    <Card className = "p-2 flex-fill border-10" border = {loan.Status && loan.Status == "Approved"?"success":"light"}>
                        <Card.Title>
                            <Stack direction = "horizontal" gap = {2}>
                                <>{loan.LoanID}</>
                                <>{loan.isNew && (<Badge className = 'ms-auto' pill bg="danger">New</Badge>)}</>
                            </Stack>
                        </Card.Title>
                        <p>
                            Type: {loan.LoanType}<br />
                            Client: {loan.ClientName}
                        </p>
                        <Badge pill bg="success" className={loan.Status == "Approved"?"show":"hide"}>Approved</Badge>
                        <div className="text-align-center mt-auto w-100"><SubmitButton className = "" text = "View Client's Data" onClick = {() => handleViewData(allClients[loan.ClientIndex])} width = "90"/></div>
                        <div className="text-align-center mt-auto w-100"><SubmitButton className = "" text = "Notes" onClick = {() => handleViewNotes(loan)} width = "90"/></div>
                    </Card>
                </Col>
            ))}

            {showNoteModal && (
                <NoteModal
                    credentials = {credentials}
                    username = {username}
                    loan = {chosenLoan}
                    setLoan = {setChosenLoan}
                    allClients = {allClients}
                    setAllClients = {setAllClients}
                    allLoans = {allLoans}
                    setAllLoans = {setAllLoans}
                    isAdmin = {true}
                    onHide = {() => setShowNoteModal(false)}
                />
            )}
        </Row>  
    )
};

export default AdminLoans;